// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { hideElementOnPrint, xScreen } from "@awc/XDL/Utilities";
import { cookiePrivacyPolicyPopupStyles } from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import { css } from "styled-components";

cookiePrivacyPolicyPopupStyles.drawer = {
    position: "bottom",
    size: 100,
    cssOverrides: {
        drawerTitle: css`
            display: none;
        `,
        drawerContent: css`
            padding: 12px;
            margin: 0 auto;
            width: 100%;
        `,
        drawerBody: css`
            top: auto;
            bottom: 0;
            justify-content: center;

            ${xScreen("lt", "md")} {
                && {
                    display: flex;
                }
            }

            ${xScreen("lte", "sm")} {
                && {
                    height: 145px;
                }
            }
        `,
        scrim: css`
            top: auto;
            bottom: 0;
            ${hideElementOnPrint}
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

cookiePrivacyPolicyPopupStyles.messageGridItem = {
    width: [12, 12, 8, 8, 8],
};

cookiePrivacyPolicyPopupStyles.acceptGridItem = {
    width: [12, 6, 2, 2, 2],
};

cookiePrivacyPolicyPopupStyles.closeGridItem = {
    width: [12, 6, 2, 2, 2],
};

cookiePrivacyPolicyPopupStyles.closeButton = {
    variant: "secondary",
    css: css`
        width: 100%;
    `,
};
